import { createApiClient } from 'Network/ApiClient';

export const ActivityAgeGenderAxiosInstance =
  createApiClient('ActivityAgeGender/');